import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import { Field, useFormikContext } from 'formik';
import { Select } from 'formik-material-ui';
import MenuItem from '@material-ui/core/MenuItem';
import { COMMON_ATTRIBUTES } from '../constants';
import { QUESTIONS } from '../fieldLabels';
import { IDB_ATTRIBUTES } from '../IDB/constants';
import ShippingMethodsApiService from '../../../services/api/shippingMethods';
import withDependency from './hooks/withDependency';
import InputLabel from '../../Form/InputLabel';

const ShippingMethodField = ({
  currentValue,
  preferenceValue,
  setValue,
  assignment,
  locationAttribute
}) => {
  const { values, setStatus, initialValues } = useFormikContext();
  const locationId = values[locationAttribute];
  const printAssignment = assignment == null ? values[IDB_ATTRIBUTES.PRINT_ASSIGNMENT] : assignment;
  const originalValue = initialValues[COMMON_ATTRIBUTES.SHIPPING_METHOD];
  const originalAssignment = initialValues[IDB_ATTRIBUTES.PRINT_ASSIGNMENT];
  const [shippingMethods, setShippingMethods] = useState([]);

  useEffect(() => {
    if (locationId === null || locationId === '' || locationId === undefined) {
      return () => {};
    }
    const api = new ShippingMethodsApiService();
    // eslint-disable-next-line camelcase
    let updateShippingMethod = data => {
      setStatus(null);
      setShippingMethods(data);
    };
    setStatus('loading_shipping_methods');
    api
      .get({
        locationId,
        assignment: printAssignment,
        availableOnly: assignment == null && originalAssignment !== printAssignment
      })
      .then(({ shipping_methods: result }) => {
        updateShippingMethod(
          result.filter(item => item.available || item.id_string === originalValue)
        );
      });

    return () => {
      updateShippingMethod = () => {
        setStatus(null);
      };
    };
  }, [
    locationId,
    printAssignment,
    originalValue,
    setShippingMethods,
    setStatus,
    originalAssignment,
    assignment
  ]);

  useEffect(() => {
    if (
      shippingMethods.length === 0 ||
      (currentValue !== null && shippingMethods.find(item => item.id_string === currentValue))
    ) {
      return;
    }
    const preferredValueExists =
      preferenceValue && !!shippingMethods.find(item => item.id_string === preferenceValue);

    setValue(preferredValueExists ? preferenceValue : shippingMethods[0].id_string);
  }, [currentValue, shippingMethods, setValue, preferenceValue]);

  if (!shippingMethods.find(item => item.id_string === currentValue)) {
    return '';
  }

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{QUESTIONS[COMMON_ATTRIBUTES.SHIPPING_METHOD]}</InputLabel>
      <Field required name={COMMON_ATTRIBUTES.SHIPPING_METHOD} component={Select} labelWidth={65}>
        {shippingMethods.map(shippingMethod => {
          return (
            <MenuItem key={shippingMethod.id} value={shippingMethod.id_string}>
              {`${shippingMethod.name}`}
            </MenuItem>
          );
        })}
      </Field>
    </FormControl>
  );
};

ShippingMethodField.propTypes = {
  currentValue: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  preferenceValue: PropTypes.string,
  assignment: PropTypes.number,
  locationAttribute: PropTypes.string
};

ShippingMethodField.defaultProps = {
  currentValue: null,
  preferenceValue: null,
  assignment: null,
  locationAttribute: COMMON_ATTRIBUTES.SHIPPING_LOCATION
};

export default withDependency(ShippingMethodField);
